import React from 'react';
import { Icon } from '../core/Icon.jsx';

export function EmptyState({ icon = 'search', title, children, action, className = '', ...rest }) {
  return (
    <div className={['sp-empty', className].filter(Boolean).join(' ')} {...rest}>
      <span className="sp-empty__icon"><Icon name={icon} size={18} /></span>
      {title && <div className="sp-empty__title">{title}</div>}
      {children && <div className="sp-empty__body">{children}</div>}
      {action && <div style={{ marginTop: 'var(--space-2)' }}>{action}</div>}
    </div>
  );
}
